import axios, { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useAxios, apiEndpoints } from 'api';
import { AutoAlertStatus } from 'components';
import {
  TransportAdditionalParam,
  TransportDangerousGoodsModel,
  TransportDriverLicenseModel,
} from 'api/types/Transport';

// START Transport Driver license and ADR

const useGetTransportDriveLicense = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: TransportAdditionalParam) => void,
  TransportDriverLicenseModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    TransportDriverLicenseModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: TransportAdditionalParam) => {
      ax.get<TransportDriverLicenseModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/transport/driver-license`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

const useGetTransportDangerousGoods = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: TransportAdditionalParam) => void,
  TransportDangerousGoodsModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    TransportDangerousGoodsModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: TransportAdditionalParam) => {
      ax.get<TransportDangerousGoodsModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/transport/adr`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

// END Transport Driver license and ADR

export default {
  useGetTransportDriveLicense,
  useGetTransportDangerousGoods,
};
